var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcResourceOn = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 34,
  height: 34,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#ic-resource-on_svg__a)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 17,
  cy: 17,
  r: 17,
  fill: "#fff"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#ic-resource-on_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#C9BBF6",
  d: "M21 8c-1.66 0-3 1.283-3 2.872v9.575c0 .526-.45.957-1 .957s-1-.43-1-.957v-9.575C16 9.283 14.66 8 13 8H8c-.55 0-1 .43-1 .957v12.447c0 1.053.89 1.915 2 1.915h6.28c.35.565.98.958 1.72.958s1.38-.393 1.72-.958H25c1.1 0 2-.862 2-1.915V8.957C27 8.431 26.55 8 26 8z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#8268D9",
  d: "M25 23.32h-6.28c-.35.564-.98.957-1.72.957s-1.38-.393-1.72-.958H9c-1.1 0-2-.861-2-1.915v1.724c0 1.053.9 1.915 2 1.915h6.28c.35.565.98.957 1.72.957s1.38-.392 1.72-.957H25c1.1 0 2-.862 2-1.915v-1.724c0 1.053-.9 1.915-2 1.915"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "ic-resource-on_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h34v34H0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "ic-resource-on_svg__b"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M7 8h20v18H7z"
})))));
export default SvgIcResourceOn;